// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`
let baseURL = 'https://development-backend.blueride.app';
let firebaseConfig = {
    apiKey: "AIzaSyAhAC8VA4wZUv2xBoSPBOYH_FFqSH_ac5Y",
    authDomain: "blueride-v2.firebaseapp.com",
    databaseURL: "https://blueride-v2.firebaseio.com",
    projectId: "blueride-v2",
    storageBucket: "blueride-v2.appspot.com",
    messagingSenderId: "260468705826",
    appId: "1:260468705826:web:65546bcd95e3eab15f987b",
    measurementId: "G-BNN4D97X69"
} 
export const environment = {
  production: false,
  url: baseURL+'/api/',
  img_url: baseURL,
  PUSHER_API_KEY: 'bc312a48ec8e2862105a',
  PUSHER_API_CLUSTER: 'eu',
  googleKey: 'AIzaSyBkOoOqQ05Ab11bvXFqLGcZDhSvTJXP9Ks',
  firebase: firebaseConfig,
  live : false,
  geminiApiKey: 'AIzaSyApd6Vd4HMpWSyeiTDnvx0ktWIpadNU2Uk',
  geminiProjectId: 'blueride-lite',
  geminiRegion: 'us-central1',
  msalConfig: {
    auth: {
      clientId: '2ab5dcaa-9fb1-471d-bc7d-11ce500c74e7',
      authority: 'https://login.microsoftonline.com/6ba93e50-c19c-4f3f-84a3-ff42aee9e57f'
    }
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://development-backoffice.blueride.app/login'
  }
};


/*
// dev
let baseURL = 'https://development-backend.blueride.app';
let firebaseConfig = {
    apiKey: "AIzaSyAhAC8VA4wZUv2xBoSPBOYH_FFqSH_ac5Y",
    authDomain: "blueride-v2.firebaseapp.com",
    databaseURL: "https://blueride-v2.firebaseio.com",
    projectId: "blueride-v2",
    storageBucket: "blueride-v2.appspot.com",
    messagingSenderId: "260468705826",
    appId: "1:260468705826:web:65546bcd95e3eab15f987b",
    measurementId: "G-BNN4D97X69"
} 
export const environment = {
  production: false,
  url: baseURL+'/api/',
  img_url: baseURL,
  PUSHER_API_KEY: 'bc312a48ec8e2862105a',
  PUSHER_API_CLUSTER: 'eu',
  googleKey: 'AIzaSyDqjIdjtHmnHvvjcRFloSGi6eqdl1tRGFw',
  firebase: firebaseConfig,
  live : false
};
// live
// let baseURL = 'https://backend.blueride.app';
// let firebaseConfig = {
//   apiKey: "AIzaSyAhAC8VA4wZUv2xBoSPBOYH_FFqSH_ac5Y",
//   authDomain: "blueride-v2.firebaseapp.com",
//   databaseURL: "https://blueride-v2.firebaseio.com",
//   projectId: "blueride-v2",
//   storageBucket: "blueride-v2.appspot.com",
//   messagingSenderId: "260468705826",
//   appId: "1:260468705826:web:65546bcd95e3eab15f987b",
//   measurementId: "G-BNN4D97X69"
// }
// export const environment = {

//   production: false,
//   url: baseURL+'/api/',
//   img_url: baseURL,
//   PUSHER_API_KEY: 'c9b4f87836c5d3ad204a',
//   PUSHER_API_CLUSTER: 'eu',
//   googleKey: 'AIzaSyDqjIdjtHmnHvvjcRFloSGi6eqdl1tRGFw',
//   firebase: firebaseConfig,
//   live : true
// };
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
